/**
 * Shopify template types
 * https://shopify.dev/docs/api/liquid/objects/template
 *
 */
const SHOPIFY_TEMPLATE_TYPES = {
  ARTICLE: 'article',
  COLLECTION: 'collection',
  INDEX: 'index',
  NOT_FOUND_ERROR: '404',
  PAGE: 'page',
  PRODUCT: 'product',
  SEARCH: 'search',
};

export { SHOPIFY_TEMPLATE_TYPES };
